/** BigCommerce production store name in the CFA account (no env suffix). */
export const PRODUCTION_STORE_NAME = 'CFA Institute';

export function isProductionStoreName(storeName: string): boolean {
  return storeName.trim() === PRODUCTION_STORE_NAME;
}

export function formatStoreNameForDisplay(storeName: string): string {
  return isProductionStoreName(storeName)
    ? `${storeName} (Production)`
    : storeName;
}

export function isInactiveUserStatus(status: string): boolean {
  return status.trim().toUpperCase() === 'INACTIVE';
}
